import { IconButton, WithBadge, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { WithCommentPopover } from '@webapp/platform/comment'
import messages from '../messages'

interface IExpenseCommentPopoverButtonProps {
  contentTypeId: number
  objectId: number
  userId: number
}

export const ExpenseCommentPopoverButton = ({
  contentTypeId,
  objectId,
  userId,
}: IExpenseCommentPopoverButtonProps) => {
  const intl = useProcurifyIntl()

  return (
    <WithCommentPopover
      contentID={contentTypeId}
      objectID={objectId}
      userID={userId}
      pageSize={9999}
    >
      {(commentsCount) => (
        <WithTooltip
          title={intl.formatMessage(messages.commentsToolbarButton)}
          placement='bottom'
        >
          <WithTooltip.Wrapper>
            <WithBadge
              content={commentsCount}
              ariaLabel={intl.formatMessage(messages.commentsCountAriaLabel, {
                count: commentsCount,
              })}
            >
              <IconButton
                icon='message'
                aria-label={intl.formatMessage(messages.commentsToolbarButton)}
              />
            </WithBadge>
          </WithTooltip.Wrapper>
        </WithTooltip>
      )}
    </WithCommentPopover>
  )
}

ExpenseCommentPopoverButton.displayName = 'ExpenseCommentPopoverButton'
